import React, { useState, useRef, useEffect, useContext } from "react";
import { Container, Row, Col, Form } from "react-bootstrap";
import Skeleton from "react-loading-skeleton";
import { TabNavigation } from "../../Components/TabNavigation/TabNavigation";
import { MultiSelect } from "react-multi-select-component";
import {
  BoxVentas,
  GraficaPeriodo,
  BoxMetas,
  TablaHistorico,
  TablaAgentes,
} from "../../Components/Components";
import "./Ventas.css";
import "../../pages/Dashboard/dashboard.css";
import { AuthContext } from "../../auth/AuthContext";
import { TablaOficinas } from "../Oficinas/Components";
import {
  BrowserRouter as Router,
  Redirect,
  useHistory,
} from "react-router-dom";

export const Ventas = ({ state, updateState, loadData }) => {
  let history = useHistory();
  const { usuario } = useContext(AuthContext);
  const id_usuario = usuario.id_usuario;

  const ref = useRef(null);
  const { openMenu, data, loadingData, oficinas } = state;
  const currentYear = new Date().getFullYear();
  const beforeYear = new Date(
    new Date().setFullYear(new Date().getFullYear() - 1)
  ).getFullYear();
  const [selected, setSelected] = useState([]);
  const [selectedAgentes, setSelectedAgentes] = useState("0");
  const [selectedTipos, setSelectedTipos] = useState("0");
  const [isSticky, setSticky] = useState(false);
  const [viewTab, setViewTab] = useState(0);
  const [loadDatagraficaTipo, setLoadDataGraficaTipo] = useState(false);
  const [loadDataOficinas, setLoadDataOficinas] = useState(false);
  const [selectedOficinas, setSelectedOficinas] = useState([]);

  const {
    totalCobranzaCurrent = 0,
    totalProduccionCurrent = 0,
    totalSiniestralidadCurrent = 0,
    ventasMonthCurrent = [],
    ventasYearCurrent = [],
    ventasYearBefore = [],
    ventasLast12Months = [],
    siniestralidadMonthCurrent = [],
    siniestralidaLast12Months = [],
    agentes = [],
    tipos = [],
  } = data[viewTab];
  const [dataTab, setDataTab] = useState([
    {
      name: "Dirección",
      onClick: (e) => {
        updateState({
          dataOficinas: {},
        });
        setViewTab(0);
        setSelected([]);
        setSelectedAgentes("0");
        setSelectedTipos("0");
        setLoadDataOficinas(true);
      },
    },
    {
      name: "OS",
      onClick: (e) => {
        updateState({
          dataOficinas: {},
        });
        setViewTab(1);
        setSelected([]);
        setSelectedAgentes("0");
        setSelectedTipos("0");
        setLoadDataOficinas(true);
      },
    },
    {
      name: "ODQ´S",
      onClick: (e) => {
        updateState({
          dataOficinas: {},
        });
        setViewTab(2);
        setSelected([]);
        setSelectedAgentes("0");
        setSelectedTipos("0");
        setLoadDataOficinas(true);
      },
    },
  ]);

  const handleScroll = () => {
    if (ref.current) {
      setSticky(ref.current.getBoundingClientRect().top === 62);
    }
  };

  const arrOficinas = [];
  let dataOficinas = "";
  if (viewTab != 0)
    dataOficinas = oficinas
      ? oficinas.filter((element) => element.tipo_oficina === viewTab)
      : "";
  else dataOficinas = oficinas;

  if (dataOficinas) {
    dataOficinas.map((element) => {
      arrOficinas.push({
        label: element.nombre_oficina,
        value: element.clave_oficina,
      });
    });
  }

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", () => handleScroll);
    };
  }, []);

  useEffect(() => {
    setLoadDataGraficaTipo(loadDatagraficaTipo);
  }, [loadDatagraficaTipo]);

  useEffect(() => {
    if (Object.keys(data[viewTab]).length < 1) {
      loadData(
        viewTab,
        selectedOficinas,
        selectedAgentes,
        selectedTipos,
        id_usuario
      );
    }
  }, [viewTab, loadDatagraficaTipo]);

  const { nombre,tipo } = usuario;

  if(tipo=='3' || tipo=='2'){
    history.replace("/agentes");
    return false;
  }
  
  return (
    <>
      <div className={`ws_content_wrapper ${!openMenu ? "wrapper_close" : ""}`}>
        <div className="ws_content_header ws_pl_0 ws_pr_0 mb-5">
          <TabNavigation data={dataTab} />

          <Container
            fluid
            className={`ws_header_sticky ${
              isSticky ? "shadow ws_bg_white" : ""
            } mt-st-15`}
            ref={ref}
          >
            <Row>
              <Col className="mb-2" xs={12} md={3}>
                <h1 className="ws_title_header">
                  {viewTab === 0 ? (
                    <p>Dirección</p>
                  ) : viewTab === 1 ? (
                    <p>OS</p>
                  ) : viewTab === 2 ? (
                    <p>ODQ'S</p>
                  ) : null}
                </h1>
              </Col>
              <Col className="mb-2" xs={12} md={9}>
                <Row>
                  <Col xs={12} md={4}>
                    {!loadingData ? (
                      <>
                        <h3 className="ws_select_type">Oficinas</h3>
                        <MultiSelect
                          options={arrOficinas}
                          value={selected}
                          onChange={(props) => {
                            setSelected(props);

                            const newOficinas = [];
                            props.map((element) => {
                              newOficinas.push(element.value);
                            });
                            setSelectedOficinas(newOficinas);

                            setLoadDataGraficaTipo(true);
                            updateState({
                              loadingData: true,
                            });

                            if (arrOficinas.length === props.length) {
                              loadData(
                                viewTab,
                                [],
                                selectedAgentes,
                                selectedTipos,
                                id_usuario
                              );
                              setSelectedOficinas([]);
                            } else {
                              loadData(
                                viewTab,
                                props,
                                selectedAgentes,
                                selectedTipos,
                                id_usuario
                              );
                            }
                          }}
                          labelledBy="Selecciona una oficina"
                          overrideStrings={{
                            allItemsAreSelected: "Se ha seleccionado todo",
                            clearSearch: "Limpiar Búsqueda",
                            noOptions: "No hay datos",
                            search: "Buscar",
                            selectAll: "Seleccionar todo",
                            selectAllFiltered: "Seleccionar todo (Filtrado)",
                            selectSomeItems: "Elegir una oficina...",
                          }}
                          hasSelectAll={true}
                        />
                      </>
                    ) : (
                      <Skeleton />
                    )}
                  </Col>
                  {/* <Col xs={12} md={4}>
                    {
                      (!loadingData) ?
                        <>
                          <h3 className="ws_select_type">Agentes</h3>
                          <Form.Select
                            aria-label="select agentes"
                            className="ws_select_opt"
                            value={selectedAgentes}
                            onChange={
                              (e) => {
                                updateState({
                                  loadingData: true
                                })
                                setLoadDataGraficaTipo(true)
                                setLoadDataOficinas(true)
                                setSelectedAgentes(e.target.value);
                                loadData(viewTab, selected, e.target.value, selectedTipos,id_usuario)
                              }
                            }
                          >
                            {
                              agentes.map((element, index) => (
                                <option value={element.value} key={index}>{element.name}</option>
                              ))
                            }
                          </Form.Select>
                        </>
                        : <Skeleton />
                    }
                  </Col> */}
                  <Col xs={12} md={4}>
                    {!loadingData ? (
                      <>
                        <h3 className="ws_select_type">Tipos</h3>
                        <Form.Select
                          /* defaultValue={selectedTipos} */
                          aria-label="select tipos"
                          className="ws_select_opt"
                          value={selectedTipos}
                          onChange={(e) => {
                            updateState({
                              loadingData: true,
                            });
                            setLoadDataGraficaTipo(true);
                            setLoadDataOficinas(true);
                            setSelectedTipos(e.target.value);
                            loadData(
                              viewTab,
                              selected,
                              selectedAgentes,
                              e.target.value,
                              id_usuario
                            );
                          }}
                        >
                          {tipos.map((element, index) => (
                            <option
                              value={element.value}
                              // selected={
                              //   selectedTipos === element.value ? true : false
                              // }
                              key={index}
                            >
                              {element.name}
                            </option>
                          ))}
                        </Form.Select>
                      </>
                    ) : (
                      <Skeleton />
                    )}
                  </Col>
                </Row>
              </Col>
            </Row>
          </Container>

          <Container fluid className="mt-5">
            <Row className="mb-2"></Row>
            <Row>
              <BoxVentas
                state={state}
                updateState={updateState}
                loading={loadingData}
                tagColor={ventasMonthCurrent.color}
                title={ventasMonthCurrent.titulo}
                value={"$" + number_format(ventasMonthCurrent.valor, 2)}
                percent={ventasMonthCurrent.porcentaje}
                date={ventasMonthCurrent.subtitulo}
              />
              <BoxVentas
                state={state}
                updateState={updateState}
                loading={loadingData}
                tagColor={ventasYearBefore.color}
                title={ventasYearBefore.titulo}
                value={"$" + number_format(ventasYearBefore.valor, 2)}
                percent={ventasYearBefore.porcentaje}
                date={ventasYearBefore.subtitulo}
              />
              <BoxVentas
                state={state}
                updateState={updateState}
                loading={loadingData}
                tagColor={ventasYearCurrent.color}
                title={ventasYearCurrent.titulo}
                value={"$" + number_format(ventasYearCurrent.valor, 2)}
                percent={ventasYearCurrent.porcentaje}
                date={ventasYearCurrent.subtitulo}
              />
              <BoxVentas
                state={state}
                updateState={updateState}
                loading={loadingData}
                tagColor={ventasLast12Months.color}
                title={ventasLast12Months.titulo}
                value={"$" + number_format(ventasLast12Months.valor, 2)}
                percent={ventasLast12Months.porcentaje}
                date={ventasLast12Months.subtitulo}
              />
              <BoxVentas
                state={state}
                updateState={updateState}
                loading={loadingData}
                tagColor={siniestralidadMonthCurrent.color}
                title={siniestralidadMonthCurrent.titulo}
                value={siniestralidadMonthCurrent.valor + "%"}
                percent={siniestralidadMonthCurrent.porcentaje}
                date={siniestralidadMonthCurrent.subtitulo}
              />
              <BoxVentas
                state={state}
                updateState={updateState}
                loading={loadingData}
                tagColor={siniestralidaLast12Months.color}
                title={siniestralidaLast12Months.titulo}
                value={siniestralidaLast12Months.valor + "%"}
                percent={siniestralidaLast12Months.porcentaje}
                date={siniestralidaLast12Months.subtitulo}
              />
            </Row>

            <Row>
              <GraficaPeriodo
                state={state}
                updateState={updateState}
                year={currentYear}
                selected={currentYear}
                opt={viewTab}
                loadDatagraficaTipo={loadDatagraficaTipo}
                setLoadDataGraficaTipo={setLoadDataGraficaTipo}
                dataSelect={{
                  selectedOficinas,
                  selectedTipos,
                  selectedAgentes,
                }}
              />

              <GraficaPeriodo
                state={state}
                updateState={updateState}
                year={currentYear}
                selected={beforeYear}
                opt={viewTab}
                loadDatagraficaTipo={loadDatagraficaTipo}
                setLoadDataGraficaTipo={setLoadDataGraficaTipo}
                dataSelect={{
                  selectedOficinas,
                  selectedTipos,
                  selectedAgentes,
                }}
              />
            </Row>

            {/*<Row>
              <BoxMetas
                year={'2021'}
                totalCobranza={totalCobranzaCurrent}
                totalProduccion={totalProduccionCurrent}
                totalSiniestralidad={totalSiniestralidadCurrent}
              />
            </Row>*/}

            <Row>
              <TablaHistorico
                initState={state}
                updateState={updateState}
                opt={viewTab}
              />
              <TablaOficinas
                state={state}
                updateState={updateState}
                loadDataOficinas={loadDataOficinas}
                setLoadDataOficinas={setLoadDataOficinas}
                dataSelect={{ opt: viewTab, selectedTipos, selectedAgentes }}
              />
              {/* {
                (viewTab === 2)
                  ? <TablaAgentes initState={state} updateState={updateState} />
                  : null
              } */}
            </Row>
          </Container>
        </div>
      </div>
    </>
  );
  //FORMATO EN NÚMEROS
  function number_format(number, decimals, decPoint, thousandsSep) {
    number = (number + "").replace(/[^0-9+\-Ee.]/g, "");
    var n = !isFinite(+number) ? 0 : +number;
    var prec = !isFinite(+decimals) ? 0 : Math.abs(decimals);
    var sep = typeof thousandsSep === "undefined" ? "," : thousandsSep;
    var dec = typeof decPoint === "undefined" ? "." : decPoint;
    var s = "";
    var toFixedFix = function (n, prec) {
      var k = Math.pow(10, prec);
      return "" + (Math.round(n * k) / k).toFixed(prec);
    };
    s = (prec ? toFixedFix(n, prec) : "" + Math.round(n)).split(".");
    if (s[0].length > 3) {
      s[0] = s[0].replace(/\B(?=(?:\d{3})+(?!\d))/g, sep);
    }
    if ((s[1] || "").length < prec) {
      s[1] = s[1] || "";
      s[1] += new Array(prec - s[1].length + 1).join("0");
    }
    return s.join(dec);
  }
};
